import { render } from "./IconPlusSmall.vue?vue&type=template&id=188b7a24"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlusSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "188b7a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('188b7a24', __exports__)) {
    api.reload('188b7a24', __exports__)
  }
  
  module.hot.accept("./IconPlusSmall.vue?vue&type=template&id=188b7a24", () => {
    api.rerender('188b7a24', render)
  })

}


export default __exports__